export default window.jQuery


/** WEBPACK FOOTER **
 ** ./main/assets/article/js/src/window-jquery.js
 **/